/* src/app/admin/services-list/services-list.component.scss */
/*# sourceMappingURL=services-list.component-574UC7XI.css.map */
